import A2Logo from '@/components/icons/logos/A2Logo'
import ARATLogo from '@/components/icons/logos/ARATLogo'
import BielefieldLogo from '@/components/icons/logos/BielefeldLogo'
import CarDressLogo from '@/components/icons/logos/CarDressLogo'
import FwbLogo from '@/components/icons/logos/FwbLogo'
import GmbHGuruLogo from '@/components/icons/logos/GmbHGuruLogo'
import GutachterFrankenLogo from '@/components/icons/logos/GutachterFrankenLogo'
import HAPPALogo from '@/components/icons/logos/HAPPALogo'
import HDILogo from '@/components/icons/logos/HDILogo'
import HOLYLogo from '@/components/icons/logos/HOLYLogo'
import IGNISLogo from '@/components/icons/logos/IGNISLogo'
import JustdentitLogo from '@/components/icons/logos/JustdentitLogo'
import KoerperfitLogo from '@/components/icons/logos/KoerperfitLogo'
import MaxWeigelLogo from '@/components/icons/logos/MaxWeigelLogo'
import OerlinghausenLogo from '@/components/icons/logos/OerlinghausenLogo'
import PatriaLogo from '@/components/icons/logos/PatriaLogo'
import SchilderaufstellerLogo from '@/components/icons/logos/SchilderaufstellerLogo'
import SennariehnLogo from '@/components/icons/logos/SennariehnLogo'
import SteuernGestaltenLogo from '@/components/icons/logos/SteuernGestaltenLogo'
import StudioGoldenLogo from '@/components/icons/logos/StudioGoldenLogo'
import WellwoodLogo from '@/components/icons/logos/WellwoodLogo'
import WfnLogo from '@/components/icons/logos/WfnLogo'
import WhyNotDeliLogo from '@/components/icons/logos/WhyNotDeliLogo'
import { Fragment } from 'react'

const HomeInfiniteHorizonalPartnersLine = () => {
  const logos = [
    A2Logo,
    ARATLogo,
    BielefieldLogo,
    CarDressLogo,
    FwbLogo,
    GmbHGuruLogo,
    GutachterFrankenLogo,
    HAPPALogo,
    HDILogo,
    HOLYLogo,
    IGNISLogo,
    JustdentitLogo,
    KoerperfitLogo,
    MaxWeigelLogo,
    OerlinghausenLogo,
    PatriaLogo,
    SchilderaufstellerLogo,
    SennariehnLogo,
    SteuernGestaltenLogo,
    StudioGoldenLogo,
    WellwoodLogo,
    WfnLogo,
    WhyNotDeliLogo
  ]

  // Don't randomize on server to avoid hydration mismatches
  const randomizedLogos = logos

  return (
    <div className="lg:w-dvw -mx-8 lg:ml-[calc(50%-50dvw)] lg:mx-auto flex  bg-accent mt-24 mb-24 lg:mt-32 lg:mb-32 overflow-hidden gap-24">
      <ul className="flex items-center relative justify-center py-8 gap-24 [&_li_svg]:h-12 [&_li_svg]:w-auto [&_li_svg]:max-w-40 [&_li_img]:h-12 [&_li_img]:w-auto [&_li_img]:max-w-40 [&_li_img]:object-contain animate-infinite-scroll">
        {[1, 2].map((item) => (
          <Fragment key={item}>
            {randomizedLogos.map((LogoComponent, index) => (
              <li key={`${item}-${index}`} className="flex">
                <LogoComponent />
              </li>
            ))}
          </Fragment>
        ))}
      </ul>
      <ul className="flex items-center justify-center py-8 gap-24 [&_li_svg]:h-12 [&_li_svg]:w-auto [&_li_svg]:max-w-40 [&_li_img]:h-12 [&_li_img]:w-auto [&_li_img]:max-w-40 [&_li_img]:object-contain animate-infinite-scroll" aria-hidden="true">
        {[3, 4].map((item) => (
          <Fragment key={item}>
            {randomizedLogos.map((LogoComponent, index) => (
              <li key={`${item}-${index}`} className="flex">
                <LogoComponent />
              </li>
            ))}
          </Fragment>
        ))}
      </ul>
    </div>
  )
}

export default HomeInfiniteHorizonalPartnersLine
